module.exports = __webpack_public_path__ + "static/media/logoAlt.dfe8a205.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoAlt.svg
// module id = 757
// module chunks = 0